// App.jsx
import React, { useState } from 'react';
import GameLoading from './GameLoading';
import SplashScreen from './SplashScreen';
//import LoadingScreen from './LoadingScreen';
import AnimationTest from './AnimationTest';
import Loading from './Loading';
import HomeScreen from './HomeScreen';
import PlayerSelectionScreen from './PlayerSelectionScreen';
import LobbyScreen from './LobbyScreen';
import SettingScreen from './SettingScreen';
import GameBoard from './GameBoard';
import Forfiet from './Forfiet';
import BattleScreen from './BattleScreen';
import AIController from './AIController';
import DiceRoller from './DiceRoller';



export const ScreenContext = React.createContext();

const App = () => {
  const [currentScreen, setCurrentScreen] = useState('GameLoading');

  const handleScreenChange =  async (screen) => {
    setCurrentScreen(screen);

    // Simulate some asynchronous operation
    await new Promise(resolve => setTimeout(resolve, 1000));
    // Resolve the promise to signal the completion of the screen change
    return Promise.resolve();

  };

  let screenComponent;

  console.log(`Current Scene ====> ${currentScreen}`);

  switch (currentScreen) {
    case 'AnimationTest':
      screenComponent = <AnimationTest/>
      break;
    case 'GameLoading':
      screenComponent = <GameLoading/>
      break;
    case 'Splash':
      screenComponent = <SplashScreen />;
      break;
    case 'Home':
     // console.log('Mouted Home Screen');
      screenComponent =  <HomeScreen/>;
      break;
    case 'Loading':
      // console.log('Mouted Loading Screen');
        screenComponent = <Loading/>;  
      break;
    case 'PlayerSelection':
      console.log(`Current Scene ====> ${currentScreen}`);
      screenComponent = <PlayerSelectionScreen/>;
      break;
    case 'Lobby':
      screenComponent = <LobbyScreen/>  
      break;
    case 'Setting':
      screenComponent = <SettingScreen/>  
      break;  
    case 'Forfiet':
      screenComponent = <screenComponent/>
      break;
    case 'Battle':
      screenComponent = <BattleScreen />;
      break;
    case 'Game':
      screenComponent = <GameBoard />;
      break;
    default:
      screenComponent = <SplashScreen />;
  }

  const [showIndexHtml, setShowIndexHtml] = useState(true);


  const handler = event => event.preventDefault();

  document.onmousedown = () => document.addEventListener("mousemove", handler);
  document.onmouseup = () => document.removeEventListener("mousemove", handler);
  document.onselectstart = () => document.removeEventListener("mousemove", handler);
  


  /* <ScreenContext.Provider value={handleScreenChange}>
      <div className="app">
        {screenComponent}
      </div>
    </ScreenContext.Provider>

  */
    const indexPath = './index.html';

  return (
  
    <ScreenContext.Provider value={handleScreenChange}>
    <div className="app">
      {screenComponent}
      
      
    </div>
  </ScreenContext.Provider>
  
  );
};

export default App;